var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{staticClass:"oc-tag mb-2",domProps:{"innerHTML":_vm._s(_vm.wrapperKeyword(_vm.k, _vm.v))}})
}
var staticRenderFns = []

export { render, staticRenderFns }